import React from "react";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import ReactDOMClient from "react-dom/client";
import "./index.css";

const app = (
	
		<BrowserRouter>
			<AuthProvider>
				<App />
			</AuthProvider>
		</BrowserRouter>
	
);

const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(app);

// const root = ReactDOMClient.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     {app}
//   </React.StrictMode>
// );
//ReactDOM.render(app, document.getElementById("root"))
//serviceWorker.register();
serviceWorker.unregister();
